import {
  AppStore as AppStoreIcon,
  Facebook as FacebookIcon,
  GooglePlay as GooglePlayIcon,
  Instagram as InstagramIcon,
  Linkedin as LinkedinIcon,
  Mail as MailIcon,
  Omnicart as OmnicartIcon,
  Phone as PhoneIcon,
} from 'components/icons';

import React from 'react';
import { useHistory } from 'react-router';
import useConfig from 'hooks/useConfig.js';
import { Typography } from '@mui/material';
import { StyledFooter } from './styles.js';

function InfoFooter() {
  const history = useHistory();
  const {
    general: {
      name,
      email,
      phone,
      socialMedia = {},
      becomeDriverLink,
      becomePartnerLink,
    },
    web: {
      downloadApp = {},
    },
  } = useConfig();

  return (
    <StyledFooter>
      <div className="layout">
        <div className="contacts">
          <img src="/logo.png" alt="Logo-footer" />
          <div className="social">
            {socialMedia?.linkedin ? (
              <a
                href={socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedinIcon />
              </a>
            ) : null}
            {socialMedia?.instagram ? (
              <a
                href={socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </a>
            ) : null}
            {socialMedia?.facebook ? (
              <a
                href={socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </a>
            ) : null}
          </div>
        </div>

        <div className="box">
          <Typography type="text-m-b">Service</Typography>
          <Typography
            onClick={() => (becomePartnerLink ? window.open(becomePartnerLink, '_blank', 'noopener,noreferrer') : history.push('/become-partner'))}
          >
            Become a
            {' '}
            { name }
            {' '}
            partner
          </Typography>
          <Typography
            onClick={() => (becomeDriverLink ? window.open(becomeDriverLink, '_blank', 'noopener,noreferrer') : history.push('/become-driver'))}
          >
            Become a
            {' '}
            { name }
            {' '}
            driver
          </Typography>
        </div>

        <div className="box">
          <Typography>Contact us</Typography>
          {email ? (
            <div className="contact">
              <MailIcon />
              <span>{email}</span>
            </div>
          ) : null}
          {phone ? (
            <div className="contact">
              <PhoneIcon className="phone" />
              <span>{phone}</span>
            </div>
          ) : null}
        </div>

        <div className="apk-row">
          {downloadApp.appStoreLink && (
            <a
              target="_blank"
              href={downloadApp.appStoreLink}
              rel="noopener noreferrer"
            >
              <AppStoreIcon className="apk-download-icon apk-download-icon--app-store" />
            </a>
          )}
          {downloadApp.googlePlayLink && (
            <a
              target="_blank"
              href={downloadApp.googlePlayLink}
              rel="noopener noreferrer"
            >
              <GooglePlayIcon className="apk-download-icon apk-download-icon--play" />
            </a>
          )}
        </div>
      </div>
      <hr className="hr" />

      <p className="powered">
        Powered by
        {' '}
        <OmnicartIcon />
      </p>
    </StyledFooter>
  );
}

export default InfoFooter;
